import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { Order, PageMeta, PaymentMethod } from '@/lib/types'

export function useOrders(state?: string) {
  return useQuery({
    queryKey: ['orders', state],
    queryFn: () => api.get<{ orders: Order[]; meta: PageMeta }>('/orders', { query: { state, per_page: 30 } }),
  })
}

export function useOrder(orderId: string, options?: { poll?: boolean }) {
  return useQuery({
    queryKey: ['order', orderId],
    queryFn: () => api.get<{ order: Order }>(`/orders/${orderId}`),
    select: (data) => data.order,
    // Halaman instruksi pembayaran menanyakan status secara berkala sampai
    // pembayaran terkonfirmasi, sehingga pengguna tidak perlu menyegarkan
    // sendiri setelah membayar.
    refetchInterval: options?.poll ? 5000 : false,
  })
}

export function useCheckout() {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (input: { course_id: string; method?: PaymentMethod; channel?: string }) =>
      api.post<{ order: Order }>('/orders', input),
    onSuccess: () => client.invalidateQueries({ queryKey: ['orders'] }),
  })
}

/**
 * Simulasi pembayaran hanya tersedia di lingkungan pengembangan; endpointnya
 * tidak terdaftar sama sekali di produksi.
 */
export function useSimulatePayment(orderId: string) {
  const client = useQueryClient()

  return useMutation({
    mutationFn: () => api.post<{ order: Order }>(`/dev/orders/${orderId}/simulate-payment`),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['order', orderId] })
      client.invalidateQueries({ queryKey: ['orders'] })
      client.invalidateQueries({ queryKey: ['enrollments'] })
    },
  })
}
